import $foreign from "./foreign.cjs";
var _codePointAt = $foreign._codePointAt;
var _countPrefix = $foreign._countPrefix;
var _fromCodePointArray = $foreign._fromCodePointArray;
var _singleton = $foreign._singleton;
var _take = $foreign._take;
var _toCodePointArray = $foreign._toCodePointArray;
var _unsafeCodePointAt0 = $foreign._unsafeCodePointAt0;
export { _codePointAt, _countPrefix, _fromCodePointArray, _singleton, _take, _toCodePointArray, _unsafeCodePointAt0 };
